import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    marginTop: 10,
    "& .MuiForm-underline:after": {
      borderBottomColor: "#778899"
    },
    "& .MuiAutocomplete-input": {
      fontSize: 12
    }
  },
  labelStyle: {
    fontSize: 14
  },
  tag: {
    background: "#FFF",
    color: "#304967",
    border: "1px solid #DADADA",
    height: 20,
    "& svg.MuiChip-deleteIcon": {
      height: 18,
      width: 18,
      margin: 0
    }
  }
}));

function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const nameA = (a.code + ' ' + a.name).toUpperCase();
    const nameB = (b.code + ' ' + b.name).toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
}

const SpecialitiesDataSelect = ({
  dataSource,
  onChange,
  value,
  disabled,
  readOnly,
  label,
  classes,
  ...rest
}) => {
  const { container, labelStyle, tag } = useStyles();

  const returnFunction = dataSource => {
    return dataSource.filter(i => value.some(v => v.id === i.id));
  };

  const returnSorting = dataSource => {
    return dataSource.sort(compare);
  }

  return (
    <Autocomplete
      disabled={dataSource.length == 0 || disabled || readOnly}
      //disableClearable={false}
      options={returnSorting(dataSource)}
      classes={{ root: container, tag }}
      multiple={true}
      value={returnFunction(dataSource)}
      onChange={(e, value) => { onChange(value) }}
      getOptionLabel={option =>
        `${option.code} ${option.name}`
      }
      {...rest}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          fullWidth
          InputLabelProps={{ shrink: true, classes: { root: labelStyle } }}
        />
      )}
      closeText="Закрыть список"
      openText="Открыть список"
      clearText="Очистить"
      loadingText="Загрузка..."
      noOptionsText="Нет доступных вариантов"
    />
  );
};

export default SpecialitiesDataSelect;
